export const dnsData = [
  {
    type: 'CNAME',
    subdomain: 'storemail',
    target: 'u2887961.wl212.sendgrid.net'
  },
  {
    type: 'CNAME',
    subdomain: 's1._domainkey',
    target: 's1.domainkey.u2887961.wl212.sendgrid.net'
  },
  {
    type: 'CNAME',
    subdomain: 's2._domainkey',
    target: 's2.domainkey.u2887961.wl212.sendgrid.net'
  },
  {
    type: 'CNAME',
    subdomain: 'storelink',
    target: 'sendgrid.net'
  },
  {
    type: 'CNAME',
    subdomain: '2887961',
    target: 'sendgrid.net'
  },
  {
    type: 'CNAME',
    subdomain: 'store',
    target: 'fire-aws-nlb.dermpro.d1.rbzdns.com'
  },
  {
    type: 'TXT',
    subdomain: 'v=spf1 include:servers.mcsv.net',
    target: 'include:u2887961.wl212.sendgrid.net'
  }
];
